import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=f56b2ef8&scoped=true&style=width%3A%20100%25%3B"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=f56b2ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56b2ef8",
  null
  
)

export default component.exports